<template>
  <div class="list-item with-icon mt-2" :class="{ selected: isSelected }">
    <v-list-item-avatar
      min-width="60px"
      height="60px"
      @click="$emit('select')"
      :class="{ 'select-multiple': isSelectMultiple }"
      :tile="!isSelectMultiple"
    >
      <v-img cover :src="icon" v-if="isSelectMultiple" />
      <v-img height="30px" contain src="@/assets/svg/user-icon.svg" v-else />
    </v-list-item-avatar>
    <v-list-item-content @click="$emit('view')">
      <div class="item-right">
        <div class="description mt-2">
          <div class="d-flex" :class="{ 'flex-column': isMobile }">
            <span class="font-weight-bold">{{ candidate | fullName }}</span>
            <span class="mx-1" v-if="!isMobile"> | </span>
            <span class="booking-list-item__mono">{{ candidate.email }}</span>
          </div>
          <div class="d-flex" :class="{ 'flex-column': isMobile }">
            <div
              class="d-flex mt-1 mr-3"
              v-for="(activity, index) in activities"
              :key="index"
            >
              <p class="pr-1">{{ activity.count }}</p>
              <v-img
                :src="activity.icon"
                max-width="30px"
                height="23"
                contain
              />
            </div>
          </div>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import { size } from "lodash";

export default {
  props: {
    candidate: {
      type: Object,
      required: true
    },
    isSelectMultiple: Boolean,
    isSelected: Boolean
  },
  computed: {
    icon() {
      const icon = this.isSelected ? "selected_icon" : "unselected_icon";
      return require(`@/assets/svg/${icon}.svg`);
    },
    applicationsCount() {
      return size(this.candidate.applications);
    },
    interviewsCount() {
      return size(this.candidate.interviewSlots);
    },
    offersCount() {
      return size(this.candidate.offers);
    },
    activities() {
      return [
        {
          count: this.applicationsCount,
          icon: require("@/assets/svg/application_black_icon.svg")
        },
        {
          count: this.interviewsCount,
          icon: require("@/assets/svg/interview_icon.svg")
        },
        {
          count: this.offersCount,
          icon: require("@/assets/svg/offer_icon.svg")
        }
      ];
    }
  }
};
</script>

<style lang="scss">
.candidates {
  .list-item {
    cursor: pointer;
    border-radius: 5px;
    padding: 0 15px;
  }
  .list-item.selected {
    background-color: $selected-transparent;
  }
  .v-avatar.v-list-item__avatar.select-multiple {
    background-color: white !important;
    align-self: flex-start;
  }
  .v-avatar.v-list-item__avatar.v-avatar--tile:hover {
    border: 2px solid $primary;
  }
  .list-item .v-avatar.v-list-item__avatar {
    background-color: #c727ff30;
  }
}
</style>
